export default __webpack_public_path__ + "static/media/pro-elevate-lav-banner-2.606ea2c7.jpg";